export const externalPages = {
    ACHAuthorizationForm:
        "https://www.docusign.net/MEMBER/PowerFormSigning.aspx?PowerFormId=5c09753d-0a47-4ac0-8086-0a12575be10c",
    AppleStoreBTApp: "https://apps.apple.com/us/app/buildertrend/id504370616",
    BTTermsAndConditions: "https://buildertrend.com/terms-and-conditions/",
    BuilderHelpArticles: "https://buildertrend.com/help-articles/",
    BuildertrendCom: "https://www.buildertrend.com/",
    BuildertrendContactSupport: "https://buildertrend.com/contact-customer-support/",
    BuildertrendContactUs: "https://buildertrend.com/company/contact-us/",
    BuildertrendLegal: "https://buildertrend.com/legal/",
    BuildertrendPricing: "https://buildertrend.com/pricing/",
    BuildertrendPrivacyNotice: "https://buildertrend.com/privacy-notice/",
    BuildertrendPrivacyPolicy: "https://buildertrend.com/privacy.aspx",
    BuildertrendSelectionsSoftware: "https://buildertrend.com/buildertrend-selections-software",
    BuildertrendSupportTraining: "https://buildertrend.com/how-it-works/platform/support-training/",
    BuildertrendTermsAndConditions: "https://buildertrend.com/hostingagreement.aspx",
    BuildertrendTermsOfUse: "https://buildertrend.com/terms-of-use/",
    BuildertrendU: "https://BuildertrendU.com",
    CaseStudyKnezHomes: "https://buildertrend.com/case-study/knez-homes/",
    Facebook: "https://www.facebook.com/buildertrend/",
    GooglePlayStoreBTApp:
        "https://play.google.com/store/apps/details?id=com.BuilderTREND.btMobileApp",
    HomeDepotPrivacyPolicy: "https://www.homedepot.com/privacy/privacy-and-security-statement",
    HomeDepotTermsAndConditions: "https://www.homedepot.com/c/Terms_of_Use",
    Instagram: "https://www.instagram.com/buildertrend/",
    LearningAcademy: {
        getBLAUrl() {
            return "https://learn.buildertrend.net/";
        },
        getProjectManagementLink() {
            return `${this.getBLAUrl()}page/education#role_project-manager`;
        },
        getTakeOffLink() {
            return `${this.getBLAUrl()}buildertrend-takeoff`;
        },
        getCostCodesBestPracticesLink() {
            return `${this.getBLAUrl()}cost-codes-best-practice`;
        },
    },
    Linkedin: "https://www.linkedin.com/company/buildertrend",
    OnsiteConsultingForm:
        "https://buildertrend.com/how-it-works/additional-services/onsite-consulting/",
    PrintOutInformation:
        "https://helpcenter.buildertrend.net/en/articles/4724013-updating-company-information",
    RoleInformationServiceCloudDoc:
        "https://helpcenter.buildertrend.net/s/article/Internal-Users-Overview",
    X: "https://x.com/Buildertrend",
    XeroMFAServiceCloudHelpDoc:
        "https://helpcenter.buildertrend.net/s/article/Multi-Factor-Authentication-In-Buildertrend",
};
